import { createContext } from 'react';

import {
  NozomiReconciliation,
  RowFilter,
} from '@totem/components/administration/reconciliation/nozomi/types';

interface Context {
  loading: boolean;
  data: NozomiReconciliation | null;
  filter: RowFilter;
  expandedKeys: string[];
  onRefresh: () => void;
  onFilterChange: (filter: RowFilter) => void;
  onExpandedKeysChange: (keys: string[]) => void;
}

export default createContext<Context>({
  loading: false,
  data: null,
  filter: 'withAssets',
  expandedKeys: [],
  onRefresh: () => {},
  onFilterChange: () => {},
  onExpandedKeysChange: () => {},
});
